import * as React from 'react';

function SvgBulkHistory(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 18" {...props}>
      <path
        d="M13.655 4.84c-3.446 0-6.247 2.82-6.247 6.287 0 3.465 2.803 6.286 6.247 6.286 3.446 0 6.246-2.82 6.246-6.286.003-3.465-2.801-6.288-6.246-6.288zm0 11.394c-2.798 0-5.075-2.292-5.075-5.107 0-2.817 2.277-5.108 5.075-5.108s5.075 2.291 5.075 5.108c0 2.815-2.274 5.107-5.075 5.107zM.775 13.99a.773.773 0 00-.775.777c0 .431.346.78.773.78h5.971a8.143 8.143 0 01-.765-1.555L.775 13.99zm0-12.434h16.5a.775.775 0 00.772-.777.77.77 0 00-.774-.779H.776a.78.78 0 000 1.557v-.001zm0 9.325h4.701a8.463 8.463 0 01.19-1.555H.775a.778.778 0 000 1.555zm7.808-6.215H.775a.77.77 0 00-.773.779c0 .431.346.78.773.78h6.31a8.314 8.314 0 011.498-1.56zm5.256 6.373V9.406a.7.7 0 10-1.399 0v2.331c0 .39.314.7.699.7h2.332a.7.7 0 100-1.398h-1.632z"
        fill="#38B2A6"
      />
    </svg>
  );
}

export default SvgBulkHistory;
